import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PaginationDto, ResponsePackage } from '../models/util.model';
import { BaseVoltage } from '../models/base-voltage.model';
import { SHARED_LIB_CONFIG, SharedLibConfig } from '../config/lib-config';

@Injectable({
  providedIn: 'root'
})
export class BaseVoltageService {
  private pathApi: string;
  constructor(private http: HttpClient, @Inject(SHARED_LIB_CONFIG) private config: SharedLibConfig) {
    this.pathApi = this.config.pathApi + 'cim/basevoltage/';
  }

  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getAll(dataIn: any) {
    return this.http.post<ResponsePackage<PaginationDto<BaseVoltage>>>(
      `${this.pathApi}getAll`,
      dataIn,
      { headers: this.headers, observe: 'response' }
    );
  }

  createOrUpdate(model: BaseVoltage) {
    return this.http.post<ResponsePackage<any>>(
      `${this.pathApi}createOrUpdate`,
      model,
      { headers: this.headers, observe: 'response' }
    );
  }

  delete(id: number) {
    return this.http.delete<ResponsePackage<any>>(
      `${this.pathApi}delete?id=${id}`,
      { headers: this.headers, observe: 'response' }
    );
  }

   getAllForMappings(utilityId: number) {
    return this.http.get<ResponsePackage<any>>(
      `${this.pathApi}getAllForMappings/${utilityId}`,
      { headers: this.headers, observe: 'response' }
    );
  }
}
